// JS – hep/site_footer  (scroll-lock desktop + mobile, sem “pulo” ao fechar)
(($) => {
  "use strict";

  jQuery(($) => {
    /* -------------------------------------------------- */
    /* Elements                                          */
    /* -------------------------------------------------- */
    const $modal = $(".container-form");
    const $innerScroll = $modal.find(".white-form-bg"); // área scrollável
    const $trigger = $("li.open-contact-form");
    const $btnClose = $modal.find(".close-x");

    /* -------------------------------------------------- */
    /* Estado                                             */
    /* -------------------------------------------------- */
    let scrollY = 0; // memorize page position

    /* -------------------------------------------------- */
    /* Helpers                                            */
    /* -------------------------------------------------- */
    const touchBlock = (e) => {
      if (e.target.closest(".white-form-bg")) return; // libera dentro
      e.preventDefault();
    };

    
    const lockScroll = () => {
      scrollY = window.scrollY || window.pageYOffset;

      $("body")
        .css({
          position: "fixed",
          top: -scrollY + "px",
          left: 0,
          width: "100%",
          overscrollBehavior: "contain", // Android/Chrome
        })
        .addClass("no-scroll");

      
      document.addEventListener("touchmove", touchBlock, { passive: false });
      document.addEventListener("wheel", touchBlock, { passive: false });
    };

   
    const unlockScroll = () => {
      const html = document.documentElement;
      const prevScrollBehavior = html.style.scrollBehavior || "";

      
      html.style.scrollBehavior = "auto";

      const bodyTop = parseFloat($("body").css("top")) || 0; // negativo
      $("body").attr("style", "").removeClass("no-scroll");
      window.scrollTo(0, -bodyTop); 

      html.style.scrollBehavior = prevScrollBehavior;

      document.removeEventListener("touchmove", touchBlock);
      document.removeEventListener("wheel", touchBlock);
    };

    const openModal = () => {
      $modal.addClass("open");
      lockScroll();
      $innerScroll.find("input,select,textarea").first().trigger("focus"); // opcional
      /* --------------------------------------------------
       *  close when click outside
       * -------------------------------------------------- */
     
      requestAnimationFrame(() => {
        $(document).on("mousedown.footerModal", (e) => {
          
          if ($(e.target).closest(".container-form").length) return;
          
          closeModal();
        });
      });
    };

    const closeModal = () => {
      
      const onEnd = () => {
        $modal.off("transitionend", onEnd);
        unlockScroll();
      };
      $modal.on("transitionend", onEnd);

      $modal.removeClass("open");
     
      $(document).off("mousedown.footerModal");
    };


    $modal.removeClass("open"); 
    requestAnimationFrame(() => $modal.addClass("ready")); 

    $trigger.on("click", (e) => {
      e.preventDefault();
      openModal();
    });
    $btnClose.on("click", closeModal);
    // $(document).on("keydown", (e) => { if (e.key === "Escape") closeModal(); });

    
    // $modal.on("click", (e) => { if (e.target === e.currentTarget) closeModal(); });

    $(document).on("focusin", (e) => {
      if (!$modal.hasClass("open")) return;
      // Allow focus on elements inside the modal (form inputs, close button, etc.)
      if (e.target.closest(".container-form")) return;
      // Only redirect focus if it's going outside the modal
      $innerScroll.attr("tabindex", "-1")[0].focus();
    });

    /* -------------------------------------------------- */
    /* Essential Dismiss Handler                          */
    /* -------------------------------------------------- */
    const $essentialDismiss = $("#essentialDismiss");
    const $essentialClose = $("#essentialDismissClose");
    const ESSENTIAL_STORAGE_KEY = "essentialDismissed";

    // Check if message was already dismissed in this session
    if (!sessionStorage.getItem(ESSENTIAL_STORAGE_KEY)) {
      // Show the message after a brief delay for better UX
      setTimeout(() => {
        $essentialDismiss.addClass("show");
      }, 500);
    }

    // Handle dismiss button click
    $essentialClose.on("click", () => {
      $essentialDismiss.removeClass("show");
      // Set session storage flag
      sessionStorage.setItem(ESSENTIAL_STORAGE_KEY, "true");
    });
  });
})(jQuery);
